module.exports = __webpack_public_path__ + "static/img/patent-swiper-5.1a42643.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/patent-swiper-5.png
// module id = KR6m
// module chunks = 1